import { render, staticRenderFns } from "./TranProgramCreateDetail.vue?vue&type=template&id=86678f18"
import script from "./TranProgramCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranProgramCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranProgramCreateDetail.vue?vue&type=style&index=0&id=86678f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports